import React, { PropsWithChildren } from "react";
import DKFormInputLabelContainer, {
  DKFormInputLabelContainerProps,
} from "./formInputContainer/DKFormInputLabelContainer";
import TextField from "@mui/material/TextField";
import { isEmpty } from "../../../../helpers/utilsTS";

const inputLabelProps: DKFormInputLabelContainerProps = undefined;
type FormTextInputProps = PropsWithChildren<{
  id?: string;
  className?: string;
  size?: typeof inputLabelProps.size;
  disabled?: boolean;
  variant?: "outlined" | "standard" | "filled";
  dataTestId?: string;
  name: string;
  type?: string;
  InputProps?: object;
  SelectProps?: object;
  select?: boolean;
  required?: boolean;
  label: string;
  customErrorLabel?: string;
  showLabel?: boolean;
  value: string | number;
  onlyNumeric?: boolean;
  fullWidth?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}>;

const DKFormTextInput = ({
  id,
  className = "",
  size,
  disabled = false,
  variant = "outlined",
  dataTestId = "",
  name,
  type = "text",
  select = false,
  SelectProps = {},
  InputProps = {},
  required = false,
  label,
  customErrorLabel = "",
  showLabel = false,
  value,
  fullWidth = true,
  children,
  onChange,
  onBlur,
  onKeyDown,
}: FormTextInputProps) => {
  const isError =
    (required && isEmpty(String(value))) || customErrorLabel !== "";

  let errorLabel;

  if (isError) {
    errorLabel = customErrorLabel || `${label} is required`;
  } else {
    errorLabel = null;
  }

  return (
    <DKFormInputLabelContainer label={label} className={className} size={size}>
      <TextField
        id={id}
        disabled={disabled}
        variant={variant}
        data-testid={dataTestId}
        name={name}
        type={type}
        select={select}
        SelectProps={SelectProps}
        InputProps={InputProps}
        required={required}
        label={showLabel ? label : ""}
        value={value}
        fullWidth={fullWidth}
        error={isError}
        helperText={errorLabel}
        onChange={onChange}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
      >
        {children}
      </TextField>
    </DKFormInputLabelContainer>
  );
};

export default DKFormTextInput;
